import { PAGE_TYPE_HK } from './constants'

export function productsHkOrFb(products, type) {
  if (type === PAGE_TYPE_HK) return products.filter((product) => !product.category.isFb)
  else return products
}
